import { faModx } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import {
  faAnchor,
  faHistory,
  faPaperPlane,
  faToolbox,
  faUser,
  faUsers,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";
import React, { Fragment } from "react";
import FontAwesome from "../../utility/fontAwesome/fontAwesome";
import CheckUnckeck from "../../utility/templete/checkUnckeck";
import AlertCard from "./panel/alertCard";
import CoverBunner from "./panel/coverBunner";
import VOP from "./panel/vop";
import { toNumeric } from "../../utility/stringExtensions";
const FacilitiesAndTariffs = () => {
  return (
    <div className="container">
      <div class="card text-center">
        <div class="card-header text-bold" style={{ fontSize: "40px" }}>
          خرید پنل اس ام اس کاربری
        </div>
        <div className="card-body">
          <h5 className="card-title">لیست تعرفه سامانه پیامکی</h5>
          <p className="card-text">
            <div className="form-group row col-md-12 text-justify">
              <table className="table text-justify">
                <thead className="thead-light">
                  <tr>
                    <th></th>
                    <th></th>
                    <th scope="col">برنزی 99 هزارتومان/دائمی</th>
                    <th scope="col">نقره ای 299 هزارتومان/دائمی</th>
                    <th scope="col">طلائی 599 هزارتومان/دائمی</th>
                    <th scope="col">الماس 999 هزارتومان/دائمی</th>
                    <th scope="col">ویژه 1 میلیون 599 هزارتومان/دائمی</th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faPaperPlane} title="ارسال" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه دریافت پیامک</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه پایه ارسال پیامک</th>
                    <th scope="col">104</th>
                    <th scope="col">97</th>
                    <th scope="col">88</th>
                    <th scope="col">77</th>
                    <th scope="col">60</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط خدماتی (بدون نیاز به مدارک)</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال به بلکلیست باشگاه مشتریان</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال پیامک حاوی لینک</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال پیامک تکی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال تدریجی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال هوشمند کلمات کلیدی</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال متناظر</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال از روی نقشه گوگل</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال منطقه ای ، کشوری</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال هدفمند مشاغل</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال هدفمند مشاغل استانها</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال با تفکیک استان و شهر (کلی)</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال با تفکیک استان و شهر (پیش شماره)</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ایرانسل تفکیک استان و شهر</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال پیام صوتی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال پیامک گروهی (انبوه)</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال کدپستی همراه اول (زن/مرد)</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال کدپستی ایرانسل (زن/مرد)</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال جنسیت و سن</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">دکل ایرانسل (BTS)</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faHistory} title="ارسال زماندار" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال زمانبدی شده</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال هوشمند زماندار</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال متناظر زماندار</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پیامک سر رسید</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faEnvelope} title="پیام ها" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">گزارش پیامک های ارسالی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">گزارش پیامک های دریافتی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">بازگشت اعتبار پیامک های ناموفق</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faWrench} title="امکانات" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تلفن ثابت ابری</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">دفترچه تلفن پیشرفته</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">اضافه به لیست خودکار</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">نظرسنجی و قرعه کشی</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">مسابقه پیامکی پیشرفته</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال کد هدیه</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">کد خوان</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">لیست سیاه</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faModx} title="ابزار ویژه" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">نوبت دهی هوشمند</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">منشی هوشمند</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پیامک مناسبتی</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پیامک یادآوری اقساط</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پاسخگوی خودکار</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">انتقال پیامک</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تحلیلگر و فیلتر پیامک</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ایمیل</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال از موبایل</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">همکاران</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال کارت ویزیت</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faAnchor} title="پشتیبانی" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پشتیبانی تلفنی، آنلاین و تیکت ها</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">راهنمای سامانه</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارائه وبسرویس API</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">وبسرویس ارسال پترن</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">ارسال آنی پیامک OTP</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پشتیبانی از تمام افزونه های ippanel</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">پشتیبانی از افزونه های پترنی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">آزمایشگاه پیامک</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">استفاده از پنل در گوشی موبایل</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faToolbox} title="تنظیمات" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تنظیمات سامانه</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">قابلیت پرداخت آنلاین</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تراکنش های مالی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">انتقال ترافیک دریافت به URL</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">درج متون سریع</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faUsers} title="خطوط عمومی" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط رند عمومی از اپراتور 1000</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط رند عمومی از اپراتور 2000</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط رند عمومی از اپراتور 3000</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط رند عمومی از اپراتور 5000</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط رند عمومی از اپراتور 021</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th scope="col" colSpan="7">
                      <FontAwesome icon={faUser} title="خطوط اختصاصی" />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط اختصاصی هدیه 50001</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط اختصاصی هدیه 50002</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خط هدیه متناظر تلفن ثابت</th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={0} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">قابلیت انتخاب خطوط اختصاصی هدیه </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">خرید آنلاین خط اختصاصی دلخواه</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">بازگشت اعتبار پیامک های مسدودی</th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                    <th scope="col">
                      <CheckUnckeck value={1} />
                    </th>
                  </tr>
                </thead>
                <thead className="bg-info border-border-purple">
                  <tr>
                    <th></th>
                    <th>تعرفه ها (برحسب تومان)</th>
                    <th scope="col">برنزی</th>
                    <th scope="col">نقره ای</th>
                    <th scope="col">طلائی</th>
                    <th scope="col">الماس</th>
                    <th scope="col">ویژه</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه دریافت پیامک</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه ارسال اپراتور 50001 و 50009</th>
                    <th scope="col">114</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">75</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه ارسال اپراتور 50002 و 50005</th>
                    <th scope="col">104</th>
                    <th scope="col">97</th>
                    <th scope="col">88</th>
                    <th scope="col">77</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه ارسال اپراتور 50004</th>
                    <th scope="col">114</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه اپراتور 1000</th>
                    <th scope="col">114</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه پیامک اپراتور 2000</th>
                    <th scope="col">114</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه پیامک اپراتور 3000</th>
                    <th scope="col">114</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه هر پیامک از اپراتور 021و026</th>
                    <th scope="col">114</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                {/* <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه ارسال باشگاه مشتریان</th>
                    <th scope="col">22/5</th>
                    <th scope="col">20/8</th>
                    <th scope="col">18/8</th>
                    <th scope="col">16/9</th>
                    <th scope="col">16/1</th>
                  </tr>
                </thead> */}
                {/* <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه هر پیامک ارسال sim</th>
                    <th scope="col">63/4</th>
                    <th scope="col">58/5</th>
                    <th scope="col">53/1</th>
                    <th scope="col">47/7</th>
                    <th scope="col">45/4</th>
                  </tr>
                </thead> */}
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه هر پیامک از دکل bts</th>
                    <th scope="col">104</th>
                    <th scope="col">107</th>
                    <th scope="col">97</th>
                    <th scope="col">85</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                {/* <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه ارسال هر ایمیل</th>
                    <th scope="col">1/4</th>
                    <th scope="col">1/3</th>
                    <th scope="col">1/2</th>
                    <th scope="col">1/1</th>
                    <th scope="col">1</th>
                  </tr>
                </thead> */}
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">تعرفه هر ثانیه پیام صوتی</th>
                    <th scope="col">108</th>
                    <th scope="col">101</th>
                    <th scope="col">92</th>
                    <th scope="col">80</th>
                    <th scope="col">65</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">هزینه تمدید سالانه</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                    <th scope="col">رایگان</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">قیمت سامانه</th>
                    <th scope="col">{toNumeric(99000)}</th>
                    <th scope="col">{toNumeric(299000)}</th>
                    <th scope="col">{toNumeric(599000)}</th>
                    <th scope="col">{toNumeric(999000)}</th>
                    <th scope="col">{toNumeric(1599000)}</th>
                  </tr>
                </thead>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" colSpan="2">
                      همین الان ثبت نام کنید!
                    </th>
                    <th scope="col" colSpan="5">
                      <a
                        href="http://sms.sayyehban.ir/register.jspd"
                        className="btn btn-info"
                        style={{ width: "100%" }}
                      >
                        همین الان ثبت نام کن
                      </a>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          </p>
        </div>
      </div>
      <br />
      <br />
      <CoverBunner
        description={
          <ol type="1" className="text-justify">
            <li>10 ریال مصوب مجلس به تعرفه ارسال پیامک اضافه خواهد شد.</li>
            <br />
            <li>
              در اپراتورهای 50001-50009 و 500002-50005، تعرفه ارسال پیامک به
              خطوط ایرانسل، 60 درصد بیشتر می باشد.
            </li>
            <br />
            <li>
              در اپراتورهای 1000 ، 2000، 3000، 50004و خط ثابت تعرفه ارسال پیامک
              به خطوط ایرانسل، 30 درصد بیشتر می باشد.
            </li>
            <br />
            <li>
              پنل های پایینتر در هرزمان با پرداخت مابه تفاوت قابل ارتقا به پنل
              بالاتر میباشند.
            </li>
            <br />
            <li>دریافت پیامک با خطوط اختصاصی فعال و رایگان میباشد.</li>
            <br />
            <li>در همه اپراتور ها هزینه بلکلیست ها بازگشت داده میشود.</li>
            <br />
            <li>
              تمام پنل ها بصورت 24 ساعته توسط تیم سایه بان پشتیبانی میشوند.
            </li>
          </ol>
        }
      />
      <br />
      <br />
      <VOP />
      <br />
      <br />
      <AlertCard
        color="rgba(221,51,51,0.16)"
        header="ارسالهای بسیار بالایی دارید؟ پنل ویژه برای شما باصرفه تر خواهد بود"
        description={
          <Fragment>
            پنل ویژه تمام امکانات سامانه را دارد که تعرفه ارسال آن حتی 5% از
            تعرفه پنل الماس ارزانتر است
            <br />
            جهت اطلاع از شرایط دقیق پنل ویژه تماس بگیرید{" "}
            <a href="tel:09053638893">09053638893</a> -
            <a href="tel:09198362447">09198362447</a>
          </Fragment>
        }
      />
      <AlertCard
        color="#BCD4E6"
        header="تمام پنل ها دائمی و بدون نیاز به هزینه تمدید واگذار میشوند"
        description={
          <Fragment>
            در سایه بان برخلاف بسیاری از ارائه دهندگان خدمات پیامک, هزینه پنل
            فقط یکبار اخذ میشود و سالهای بعدی هیچ هزینه اضافه دیگری بابت تمدید
            پنل از کاربران دریافت نمیشود.
          </Fragment>
        }
      />
      <AlertCard
        color="#F5F5DC"
        header="اشخاص حقیقی و حقوقی زیر در خرید پنل های طلایی و الماس شامل تخفیف خواهند بود."
        description={
          <Fragment>
            بعد از ثبت نام از منوی پشتیبانی تیکت ارسال کنید تا تخفیف بصورت دستی
            اعمال شود.
            <table style={{ width: "100%", height: "126px" }} width="100%">
              <thead>
                <tr style={{ height: "18px" }}>
                  <th style={{ textAlign: "center", height: "18px" }}>ردیف</th>
                  <th style={{ height: "18px" }}>تخفیف به</th>
                  <th style={{ height: "18px" }}>میزان تخفیف</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ height: "18px" }}>
                  <td style={{ textAlign: "center", height: "18px" }}>1</td>
                  <td style={{ height: "18px" }}>موسسات خیریه رسمی</td>
                  <td style={{ height: "18px" }}>40%</td>
                </tr>
                <tr style={{ height: "18px" }}>
                  <td style={{ textAlign: "center", height: "18px" }}>2</td>
                  <td style={{ height: "18px" }}>هیئت های مذهبی</td>
                  <td style={{ height: "18px" }}>30%</td>
                </tr>
                <tr style={{ height: "18px" }}>
                  <td style={{ textAlign: "center", height: "18px" }}>3</td>
                  <td style={{ height: "18px" }}>
                    بانک ها و موسسات مالی اعتباری
                  </td>
                  <td style={{ height: "18px" }}>30%</td>
                </tr>
                <tr style={{ height: "18px" }}>
                  <td style={{ textAlign: "center", height: "18px" }}>4</td>
                  <td style={{ height: "18px" }}>
                    کارگزاری ها و نمایندگان بیمه
                  </td>
                  <td style={{ height: "18px" }}>20%</td>
                </tr>
                <tr style={{ height: "18px" }}>
                  <td style={{ textAlign: "center", height: "18px" }}>5</td>
                  <td style={{ height: "18px" }}>
                    مدارس، دانشگاه ها و آموزشگاه ها
                  </td>
                  <td style={{ height: "18px" }}>20%</td>
                </tr>
                <tr style={{ height: "18px" }}>
                  <td style={{ textAlign: "center", height: "18px" }}>6</td>
                  <td style={{ height: "18px" }}>وبسایتهای دارای اینماد</td>
                  <td style={{ height: "18px" }}>10%</td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
      />
    </div>
  );
};

export default FacilitiesAndTariffs;
